// extracted by mini-css-extract-plugin
export default {"logo":"LogoMono_logo__pPGIw","logotext":"LogoMono_logotext__x+Ja+"};